import React, { FC, useState } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { Button, Drawer, Tooltip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import './PaymentLogs.scss';
import { SCUIContent } from '../../atomic/organisms';
import { SCUINoRecordComponent } from '../../atomic/atoms';
import cachePaymentImage from '../../assets/icons/svg/pageIcons/cashPayment.svg';

import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { SCUIPaymentLogsDrawerContent, SCUICustomDataGrid } from '../../atomic/molecules';
import { PaymentQuery } from '../../services/query';
import { SCUIBreadCrumb, SCUITextFieldWithSelectBox } from '../../atomic/molecules';
import { Box, LinearProgress, Fade } from '@mui/material';
import TimeHelper from '../../utils/time';
import { PLOG } from './paymentLogs.classes';

export const PaymentLogs: FC<any> = () => {
    const { t } = useTranslation();
    const [state, setState] = React.useState(false);
    const list = () => <SCUIPaymentLogsDrawerContent selectedRow={paymentLogs} onCloseMenu={onDrawerClose} />;
    const [documentType, setDocumentType] = React.useState(1);
    const [searchedText, setSearchedText] = useState('');

    const columns: ExtendedGridColDef[] = [
        { field: 'id', headerName: 'Id', flex: 1 },
        { field: 'customerId', headerName: t('general.customerId'), flex: 1 },
        { field: 'orderNumber', headerName: t('general.orderNo'), flex: 1 },
        {
            field: 'dateTime',
            headerName: t('general.date') + ' & ' + t('general.hour'),
            flex: 1,
            renderCell: (params) => {
                return <div className={PLOG.cellDateTime}>{TimeHelper.formatDateHourSecond(params.row.dateTime)}</div>;
            },
        },
        {
            field: 'description',
            headerName: t('general.description'),
            flex: 1,
            renderCell: (params: any) => (
                <Tooltip title={params.row.description} placement="bottom-end" arrow>
                    <span className={[PLOG.cellDescription, 'table-cell-trucate'].join(' ')}>{params.row.description}</span>
                </Tooltip>
            ),
        },
        {
            field: 'data',
            headerName: t('general.status'),
            flex: 1,
            width: 10,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                if (params.row.description.includes('"Result":"Success"'))
                    return (
                        <CheckCircleIcon
                            color="success"
                            className={[PLOG.cellStatus, PLOG.statusIconSuccess, 'svg_icons'].join(' ')}
                        />
                    );
                if (params.row.description.includes('"Result":"Error"'))
                    return (
                        <CancelIcon
                            color="error"
                            className={[PLOG.cellStatus, PLOG.statusIconError, 'svg_icons'].join(' ')}
                        />
                    );
                else {
                    return (
                        <PriorityHighIcon
                            color="warning"
                            className={[PLOG.cellStatus, PLOG.statusIconWarning, 'svg_icons'].join(' ')}
                        />
                    );
                }
            },
        },
        {
            field: 'detay',
            headerName: '',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const onclick = () => {
                    setPaymentLogs(params.row);
                    onDrawerOpen();
                };
                return (
                    <div className={PLOG.cellDetailWrap}>
                        <Button className={PLOG.cellDetailButton} variant="text" size="small" onClick={onclick}>
                            {t('general.detail')}
                        </Button>
                        <Drawer
                            transitionDuration={{ enter: 500, exit: 500 }}
                            slotProps={{
                                paper: { sx: { width: '35%', boxShadow: 5 }, className: PLOG.drawerPaper },
                                backdrop: { style: { backgroundColor: 'transparent' } },
                            }}
                            anchor={'right'}
                            open={state}
                            onClose={(event, reason) => {
                                if (reason === 'backdropClick') {
                                    setState(false);
                                }
                            }}
                        >
                            {list()}
                        </Drawer>
                    </div>
                );
            },
        },
    ];

    const [paymentLogs, setPaymentLogs] = React.useState<any>();
    const onDrawerOpen = () => setState(true);
    const onDrawerClose = () => setState(false);
    const [datas, setDatas] = React.useState<any>();
    const [barDisplay, setBarDisplay] = useState(false);

    const requestSearchPaymentLogsOrderNumber = async (): Promise<any> => {
        try {
            const res = await PaymentQuery.GetPaymentLogsListOrderNumber(searchedText);
            if (res.model) {
                let parseDataOrderNumber = res.model.logs.map((item: any) => ({
                    id: item.id || '-',
                    customerId: item.customerId || '-',
                    orderNumber: item.orderNumber || '-',
                    dateTime: item.dateTime || '-',
                    description: item.description || '-',
                    data: item.data || '-',
                }));
                setDatas(parseDataOrderNumber);
                setBarDisplay(false);
            } else {
                Swal.fire(t('general.notFound'), ' ', 'error');
                setBarDisplay(false);
            }
        } catch (error) {
            setBarDisplay(false);
            console.log('Hata :>> ', error);
        }
    };
    const requestSearchPaymentLogsCustomerId = async (): Promise<any> => {
        try {
            PaymentQuery.GetPaymentLogsListCustomerId(searchedText).then((res: any) => {
                if (res.model) {
                    let parseDataCustomerId = res.model.logs.map((item: any) => {
                        return {
                            id: item.id || '-',
                            customerId: item.customerId || '-',
                            orderNumber: item.orderNumber || '-',
                            dateTime: item.dateTime || '-',
                            description: item.description || '-',
                            data: item.data || '-',
                        };
                    });
                    setDatas(parseDataCustomerId);
                    setBarDisplay(false);
                } else {
                    Swal.fire(t('general.notFound'), ' ', 'error');
                    setBarDisplay(false);
                }
            });
        } catch (error) {
            setBarDisplay(false);
            console.log('Hata :>> ', error);
        }
    };

    const sorgula = async () => {
        if (documentType === 1) {
            requestSearchPaymentLogsOrderNumber();
        } else {
            requestSearchPaymentLogsCustomerId();
        }
    };

    return (
        <SCUIContent className={PLOG.page}>
            <div className={PLOG.breadcrumbSection}>
                <SCUIBreadCrumb title={t('dashboard.paymentLog')} componentLink={'PaymentLogs'} />
            </div>

            <div className={PLOG.searchSection}>
                <SCUITextFieldWithSelectBox
                    className={PLOG.searchPaper}
                    selectClassName={PLOG.searchSelect}
                    inputClassName={PLOG.searchInput}
                    iconButtonClassName={PLOG.searchButton}
                    placeholder={' '}
                selectList={[
                    { value: 1, text: t('general.orderNo') },
                    { value: 2, text: t('general.customerId') },
                ]}
                onChangeSelect={(event: any) => {
                    setDocumentType(event.target.value as number);
                }}
                selectValue={documentType}
                onChangeTextField={(event: any) => {
                    setSearchedText(event.target.value);
                }}
                onClickButton={() => sorgula()}
                onKeyPressTextField={(e: any) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        sorgula();
                    }
                }}
                />
            </div>

            <Box className={PLOG.progressSection} sx={{ width: '100%' }}>
                <Fade in={barDisplay} unmountOnExit>
                    <LinearProgress className={PLOG.progressBar} />
                </Fade>
            </Box>
            <div className={PLOG.gridSection}>
                {datas ? (
                    <div className={PLOG.dataGridWrap}>
                        <SCUICustomDataGrid
                            rows={datas}
                            columns={columns}
                            initialState={{ columns: { columnVisibilityModel: { id: false } } }}
                        />
                    </div>
                ) : (
                    <div className={PLOG.noRecordWrap}>
                        <SCUINoRecordComponent img={cachePaymentImage} />
                    </div>
                )}
            </div>
        </SCUIContent>
    );
};
